export const formatTime = (timeStr: string): string => {
    if (!timeStr) return '';
    return timeStr.slice(0, 5);
};
